import React, { useState } from 'react';
import {
  IconButton,
} from '@mui/material';
import { Folder } from '@mui/icons-material';
import FileDialog from './FileDialog';
import { useFiles } from '../../hooks/useFiles';
import { filesAPI } from '../../services/api';

interface FilesColumnProps {
  entityType: 'CLIENT' | 'EMPLOYEE' | 'PROJECT' | 'INVOICE';
  entityId: string;
}

const FilesColumn: React.FC<FilesColumnProps> = ({ entityType, entityId }) => {
  const [dialogOpen, setDialogOpen] = useState(false);
  const { files, isLoading, deleteFile } = useFiles(entityType, entityId);

  const onViewFile = async (id: string) => {
    // Open a tab immediately so mobile browsers treat it as a user action.
    const newTab = window.open('', '_blank');

    try {
      const response = await filesAPI.download(id);
      const { downloadUrl } = response;

      if (newTab) {
        newTab.location.href = downloadUrl;
      } else {
        // Fallback when popups are blocked: navigate current tab.
        window.location.href = downloadUrl;
      }
    } catch (error) {
      if (newTab) {
        newTab.close();
      }
      alert('Failed to open file');
    }
  };

  const onDeleteFile = async (id: string) => {
    try {
      await deleteFile(id);
    } catch (error) {
      console.error('Failed to delete file:', error);
    }
  };

  const handleOpenDialog = () => {
    setDialogOpen(true);
  };

  return (
    <>
      <IconButton
        onClick={(e) => {
            e.stopPropagation();
            handleOpenDialog();
        }}
        disabled={isLoading}
        color={files.length > 0 ? 'primary' : 'default'}
      >
        <Folder />
      </IconButton>

      <FileDialog
        open={dialogOpen}
        onClose={() => setDialogOpen(false)}
        files={files}
        onViewFile={onViewFile}
        onDeleteFile={onDeleteFile}
      />
    </>
  );
};

export default FilesColumn; 